var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatarSmall = function SvgAvatarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.488c-2.07 0-3.75-1.68-3.75-3.75S5.93.988 8 .988s3.75 1.68 3.75 3.75-1.68 3.75-3.75 3.75m0-6c-1.24 0-2.25 1.01-2.25 2.25S6.76 6.988 8 6.988s2.25-1.01 2.25-2.25S9.24 2.488 8 2.488M13.299 15.009c-.62-1.56-2.44-4.19-5.3-4.19s-4.68 2.64-5.3 4.19l-1.39-.56c.95-2.37 3.27-5.14 6.7-5.14s5.75 2.77 6.7 5.14l-1.39.56z"
  })));
};
export default SvgAvatarSmall;